import React from "react";
import { useTranslation } from "react-i18next";

import CardColumn from "components/CardColumn";
import PriorityMarker from "components/Tasks/PriorityMarker";
import DueDate from "./DueDate";
import { useGetConvertedUserTime } from "hooks/useTimezone";

interface Props {
	title: string;
	status: "Active" | "Completed";
	created: string;
	dueDate: string;
	priority: "HIGH" | "LOW" | "NORMAL";
	assignee: string;
}

const TaskCard = ({
	title,
	status,
	created,
	dueDate,
	priority,
	assignee,
}: Props) => {
	const { t } = useTranslation();

	return (
		<>
			<CardColumn
				className="activity-instances-card__task__title"
				width="xl">
				{title}
			</CardColumn>
			<CardColumn
				className="activity-instances-card__task__status"
				width="xs">
				{status}
			</CardColumn>
			<CardColumn
				className="activity-instances-card__task__created"
				width="sm">
				{useGetConvertedUserTime(created)}
			</CardColumn>
			<CardColumn
				className="activity-instances-card__task__due-date"
				width="sm">
				<div className="activity-instances-card--mobile--heading__task__due-date">
					{t("main.activityInstances.tasks.headings.dueDate")}
				</div>
				<DueDate date={useGetConvertedUserTime(dueDate)} />
			</CardColumn>
			<CardColumn
				className="activity-instances-card__task__priority"
				width="xs">
				<PriorityMarker priority={priority} />
			</CardColumn>
			<CardColumn
				className="activity-instances-card__task__assignee"
				width="sm">
				{assignee || t("main.text.na")}
			</CardColumn>
		</>
	);
};

export default TaskCard;
